export default "__VITE_ASSET__LDqk1uoA__"